/**
 * The Redux store.
 *
 * Importing ../api registers every endpoint file with the single API slice, and
 * that has to happen before the store is created: a slice with no endpoints
 * registered produces a reducer that discards the cache. It is imported for its
 * side effect first, deliberately.
 */

import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { api } from "../api";
import authReducer from "./slices/authSlice";
import rideDraftReducer from "./slices/rideDraftSlice";
import rideSearchReducer from "./slices/rideSearchSlice";

export const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        auth: authReducer,
        rideSearch: rideSearchReducer,
        rideDraft: rideDraftReducer,
    },
    middleware: (getDefault) => getDefault().concat(api.middleware),
});

// Wires refetchOnFocus and refetchOnReconnect to the browser's events. Without
// this the flags on the API slice are declared and do nothing.
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
